/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1LocationStatesMutationRequest,
  PostApiV1LocationStatesMutationResponse,
  PostApiV1LocationStates400,
  PostApiV1LocationStates401,
  PostApiV1LocationStates404,
  PostApiV1LocationStates409,
  PostApiV1LocationStates500,
} from "../../types/locationStateController/PostApiV1LocationStates.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1LocationStates } from "../../clients/locationStateController/postApiV1LocationStates.ts";

export const postApiV1LocationStatesMutationKey = () =>
  [{ url: "/api/v1/location/states" }] as const;

export type PostApiV1LocationStatesMutationKey = ReturnType<
  typeof postApiV1LocationStatesMutationKey
>;

export function postApiV1LocationStatesMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiV1LocationStatesMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = postApiV1LocationStatesMutationKey();
  return mutationOptions<
    PostApiV1LocationStatesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1LocationStates400
      | PostApiV1LocationStates401
      | PostApiV1LocationStates404
      | PostApiV1LocationStates409
      | PostApiV1LocationStates500
    >,
    { data?: PostApiV1LocationStatesMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1LocationStates(data, config);
    },
  });
}

/**
 * @description Cria um novo estado vinculado a um país. A sigla e o nome devem ser únicos. **(Requer Authorization para autenticação)**
 * @summary Criar estado (Requer Authorization para autenticação)
 * {@link /api/v1/location/states}
 */
export function usePostApiV1LocationStates<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1LocationStatesMutationResponse,
      ResponseErrorConfig<
        | PostApiV1LocationStates400
        | PostApiV1LocationStates401
        | PostApiV1LocationStates404
        | PostApiV1LocationStates409
        | PostApiV1LocationStates500
      >,
      { data?: PostApiV1LocationStatesMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiV1LocationStatesMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiV1LocationStatesMutationKey();

  const baseOptions = postApiV1LocationStatesMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1LocationStatesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1LocationStates400
      | PostApiV1LocationStates401
      | PostApiV1LocationStates404
      | PostApiV1LocationStates409
      | PostApiV1LocationStates500
    >,
    { data?: PostApiV1LocationStatesMutationRequest },
    TContext
  >;

  return useMutation<
    PostApiV1LocationStatesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1LocationStates400
      | PostApiV1LocationStates401
      | PostApiV1LocationStates404
      | PostApiV1LocationStates409
      | PostApiV1LocationStates500
    >,
    { data?: PostApiV1LocationStatesMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1LocationStatesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1LocationStates400
      | PostApiV1LocationStates401
      | PostApiV1LocationStates404
      | PostApiV1LocationStates409
      | PostApiV1LocationStates500
    >,
    { data?: PostApiV1LocationStatesMutationRequest },
    TContext
  >;
}
